/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Type of the attribute
 */
export type DeviceAttributeType = (typeof DeviceAttributeType)[keyof typeof DeviceAttributeType];

export const DeviceAttributeType = {
  PROPERTY: 'property',
  REALTIME: 'realTime',
} as const;
